import React from 'react';

interface ReferralInviteProps { }
interface ReferralInviteState { }

class ReferralInvite extends React.Component<ReferralInviteProps, ReferralInviteState> {

    constructor(props_: ReferralInviteProps) {
        super(props_);

        this.state = { }
    }

    public render() {
        return (
            <div style={{
                    display: 'flex', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', fontSize: 20
            }}>Please wait. Redirecting you to the mobile app..</div>
        )
    }
}

export default ReferralInvite;